import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ModalService } from "src/app/shared/modal.service";
import { GuidedTourService } from "../guided-tour.service";

@Component({
  selector: "app-repository-container",
  templateUrl: "./repository-container.component.html",
  styleUrls: ["./repository-container.component.css"],
})
export class RepositoryContainerComponent implements OnInit {
  constructor(
    private modalService: ModalService,
    private guidedService: GuidedTourService
  ) {}
  selectedTab: string = "measures";
  showMeasuresModal: boolean = false;
  showInterventionModal: boolean = false;
  showBehaviorModal: boolean = false;

  highlightedTab: string | null = null;

  @ViewChild("measuresTab") measuresTab: ElementRef;
  @ViewChild("interventionsTab") interventionsTab: ElementRef;
  @ViewChild("behaviorsTab") behaviorsTab: ElementRef;

  ngOnInit() {
    // this.guidedService.setStartTour(1)

    const savedTab = localStorage.getItem("selectedTab");
    this.selectedTab = savedTab ? savedTab : "measures";
    this.highlightedTab = "measures";

    this.modalService.showMeasuresModal$.subscribe(() => {
      // this.selectedTab = "measures";
      // this.showMeasuresModal = true;
      // this.showInterventionModal = false;
      // setTimeout(() => this.positionModal(this.measuresTab), 0);
      this.guidedService.setStartTour(1);
    });

    this.modalService.showInterventionsModal$.subscribe(() => {
      this.selectedTab = "interventions";
      this.showInterventionModal = true;
      this.showMeasuresModal = false;
      setTimeout(() => this.positionModal(this.interventionsTab), 0);
    });

    this.modalService.tabChange$.subscribe((tabName: string) => {
      console.log("Tab changed to:", tabName);
      if (tabName == "tour-start") {
        this.selectTab("measures");
        tabName = "measures";
      }
      if (tabName == "clear") {
        this.selectTabTour("measures");
      } else {
        this.selectTabTour(tabName);
      }
    });
  }

  selectTab(tabName: string) {
    this.selectedTab = tabName;
    this.highlightedTab = null;
    if (tabName == "measures") {
      this.highlightedTab = "measures";
    }
    localStorage.setItem("selectedTab", tabName);
  }

  selectTabTour(tabName: string) {
    this.highlightedTab = tabName;
  }

  closeMeasuresModal(): void {
    this.showMeasuresModal = false;
  }

  closeInterventionModal(): void {
    this.showInterventionModal = false;
  }

  closeBehaviorModal(): void {
    this.showBehaviorModal = false;
  }

  // Position the modal directly under the Measures tab
  positionModal(tabRef: ElementRef): void {
    const modal = document.querySelector(".tooltip-modal") as HTMLElement;
    if (modal && tabRef) {
      const tabRect = tabRef.nativeElement.getBoundingClientRect();
      modal.style.top = tabRect.bottom + "px";
      modal.style.left =
        tabRect.left + tabRect.width / 2 - modal.offsetWidth / 2 + "px";
    }
  }

  prev(): void {
    if (this.showInterventionModal) {
      this.showInterventionModal = false;
      this.showMeasuresModal = true;
      this.selectedTab = "measures";
      this.highlightedTab = "measures";
      setTimeout(() => this.positionModal(this.measuresTab), 0);
    } else if (this.showMeasuresModal) {
      this.closeMeasuresModal();
      this.modalService.triggerShowHeaderModal(); // Optional back to header
    } else if (this.showBehaviorModal) {
      this.showBehaviorModal = false;
      this.showInterventionModal = true;
      this.selectedTab = "interventions";
      setTimeout(() => this.positionModal(this.interventionsTab), 0);
    }
  }

  next(): void {
    if (this.showMeasuresModal) {
      this.showMeasuresModal = false;
      this.modalService.triggerShowInterventionsModal();
    } else if (this.showInterventionModal) {
      this.showInterventionModal = false;
      this.showBehaviorModal = true;
      setTimeout(() => this.positionModal(this.behaviorsTab), 0);
    } else if (this.showBehaviorModal) {
      this.closeBehaviorModal();
    }
  }
}
